const tabs = {
  preview: {
    id: 'tab-preview',
    panelId: 'panel-preview',
    label: 'Preview'
  },
  code: {
    id: 'tab-code',
    panelId: 'panel-code',
    label: 'Code'
  }
};

export default tabs;
